import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Modal, Row, Tab, Tabs, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useEmailTemplateList, useOfferLetterList } from "Constant/apiHooks";
import { newAuthService } from "Service/Axios";
import { createTaskEmailUrl, createTaskOfferUrl } from "Constant/api";
import { Validator } from "Utils/validator";

export const OfferLetter = ({ show, isEmailTemplate, taskIds, toggle }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedOfferLetter, setSelectedOfferLetter] = useState(null);
  const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);
  const [expiryDate, setExpiryDate] = useState("");
  const [expiryDateErr, setExpiryDateErr] = useState("");
  const [offerLetterSearchText, setOfferLetterSearchText] = useState("");
  const [emailTemplateSearchText, setEmailTemplateSearchText] = useState("");

  const {
    offerLetterList,
    // loading: offerLetterLoading,
  } = useOfferLetterList();

  const {
    allEmailTemplateList,
    // loading: emailTemplaterLoading
  } = useEmailTemplateList();

  // Handle
  const handleNext = () => {
    if (currentStep < 5) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleSelectOfferLetter = (ofrLtrObj) => {
    setSelectedOfferLetter(ofrLtrObj);
    handleNext();
  };

  const handleChangeExpiryDate = (e) => {
    setExpiryDate(e.target.value);

    if (!Validator.text(e.target.value)) {
      setExpiryDateErr(t("common.messages.error.offerLetter.expiryDate.blank"));
    } else {
      setExpiryDateErr("");
    }
  };

  const handleSelectEmailTemplate = (emlTmpltObj) => {
    setSelectedEmailTemplate(emlTmpltObj);
    handleNext();
  };

  const handleChangeSearchText = (e) => {
    if (e.target.name === "offerLetterSearchText") {
      setOfferLetterSearchText(e.target.value);
    }
    if (e.target.name === "emailTemplateSearchText") {
      setEmailTemplateSearchText(e.target.value);
    }
  };

  useEffect(() => {
    if (isEmailTemplate) {
      setCurrentStep(4);
    } else {
      setCurrentStep(1);
    }
  }, [isEmailTemplate]);

  // Submit & Reset
  const onSubmitExpiryDate = () => {
    if (!Validator.text(expiryDate)) {
      setExpiryDateErr(t("common.messages.error.offerLetter.expiryDate.blank"));
    } else {
      setExpiryDateErr("");
      handleNext();
    }
  };

  const onSubmitOffer = async () => {
    setLoading(true);
    try {
      const payload = {
        taskIds,
        offerId: selectedOfferLetter.gid,
        emailTemplateId: selectedEmailTemplate.gid,
        expiryDate,
      };
      const response = await newAuthService(
        createTaskOfferUrl,
        "POST",
        payload
      );
      if (response.status) {
        toast.success(t("common.messages.notification.success.submitOffer"));
        toggle();
        setLoading(false);
      } else {
        toast.error(response.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
      setLoading(false);
    }
  };

  const onSubmitEmailTemplate = async () => {
    setLoading(true);
    try {
      const payload = {
        taskIds,
        emailTemplateId: selectedEmailTemplate.gid,
      };
      const response = await newAuthService(
        createTaskEmailUrl,
        "POST",
        payload
      );
      if (response.status) {
        toast.success(t("common.messages.notification.success.submitEmail"));
        toggle();
        setLoading(false);
      } else {
        toast.error(response.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={toggle} size="xl" >
      {currentStep === 1 && (
        <div>
          <Modal.Header closeButton>
            <Modal.Title className="text-md">
              <div className="d-flex align-items-center column-gap-2">
                {/* <button className="border-0 bg-transparent flex-auto w-10 h-10 d-flex justify-content-center align-items-center bg-slate-100 rounded-circle"><i className="bx bx-arrow-back"></i></button> */}
                Choose Offer Template
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="position-relative">
              <div className="search-div position-absolute top-0 right-0">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="pluto-search"></i>
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    name="offerLetterSearchText"
                    value={offerLetterSearchText}
                    onChange={handleChangeSearchText}
                  />
                </div>
              </div>
              <Tabs
                defaultActiveKey="tab1"
                id="template-tab-example"
                className="mb-3 nav-underline border-bottom tab-offer"
              >
                <Tab eventKey="tab1" title="All Templates">
                  <Row>
                    {offerLetterList
                      .filter(
                        (ofrLtr1) => !(ofrLtr1.archive || ofrLtr1.recylebin)
                      )
                      .filter((option) =>
                        option.name
                          .toLowerCase()
                          .includes(offerLetterSearchText.toLowerCase())
                      )
                      .map((ofrLtr2) => (
                        <Col lg={3} md={4} sm={6} xs={6} key={ofrLtr2.gid}>
                          <div className="selectRadio-box">
                            <input
                              type="radio"
                              id="a25"
                              name="check-substitution-2"
                            />
                            <label
                              className="p-4 rounded border border-2 border-slate-200 bg-slate-100 text-center"
                              htmlFor="a25"
                            >
                              <div className="offer-template rounded border border-slate-200 mb-2 h-150 bg-white overflow-hidden position-relative">
                                <button
                                  className="btn btn-primary position-absolute onSelect"
                                  onClick={() =>
                                    handleSelectOfferLetter(ofrLtr2)
                                  }
                                >
                                  Preview
                                </button>
                                <img
                                  src={
                                    ofrLtr2.pdfimagesnippet ||
                                    "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg?20200913095930"
                                  }
                                  alt={ofrLtr2.name}
                                  width={388}
                                  height={549}
                                  className="w-100 h-100 object-fit-contain"
                                />
                                <div className="radio-overlay position-absolute top-0 start-0 bottom-0 end-0 bg-white"></div>
                              </div>
                              <h4 className="mb-0 text-base font-semibold">
                                {ofrLtr2.name}
                              </h4>
                            </label>
                          </div>
                        </Col>
                      ))}
                  </Row>
                </Tab>
                <Tab eventKey="tab2" title="My Favorite">
                  <Row>
                    {offerLetterList
                      .filter((ofrLtr1) => ofrLtr1.favorite)
                      .filter((option) =>
                        option.name
                          .toLowerCase()
                          .includes(offerLetterSearchText.toLowerCase())
                      )
                      .map((ofrLtr2) => (
                        <Col lg={3} md={4} sm={6} xs={6} key={ofrLtr2.gid}>
                          <div className="selectRadio-box">
                            <input
                              type="radio"
                              id="a29"
                              name="check-substitution-2"
                            />
                            <label
                              className="p-4 rounded border border-2 border-slate-200 bg-slate-100 text-center"
                              htmlFor="a29"
                            >
                              <div className="offer-template rounded border border-slate-200 mb-2 h-150 bg-white overflow-hidden position-relative">
                                <button
                                  className="btn btn-primary position-absolute onSelect"
                                  onClick={() =>
                                    handleSelectOfferLetter(ofrLtr2)
                                  }
                                >
                                  Preview
                                </button>
                                <img
                                  src={
                                    ofrLtr2.pdfimagesnippet ||
                                    "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg?20200913095930"
                                  }
                                  alt={ofrLtr2.name}
                                  width={388}
                                  height={549}
                                  className="w-100 h-100 object-fit-contain"
                                />
                                <div className="radio-overlay position-absolute top-0 start-0 bottom-0 end-0 bg-white"></div>
                              </div>
                              <h4 className="mb-0 text-base font-semibold">
                                {ofrLtr2.name}
                              </h4>
                            </label>
                          </div>
                        </Col>
                      ))}
                  </Row>
                </Tab>
              </Tabs>
            </div>
          </Modal.Body>
        </div>
      )}

      {currentStep === 2 && (
        <div>
          <Modal.Header>
            <Modal.Title className="text-md">
              <div className="d-flex align-items-center column-gap-2">
                <button
                  className="border-0 bg-transparent flex-auto w-10 h-10 d-flex justify-content-center align-items-center bg-slate-100 rounded-circle"
                  onClick={handlePrev}
                >
                  <i className="bx bx-arrow-back"></i>
                </button>
                {selectedOfferLetter?.name}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedOfferLetter?.jsondata && (
              <div
                className="p-4"
                dangerouslySetInnerHTML={{
                  __html: selectedOfferLetter.jsondata,
                }}
              />
            )}
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <Button variant="primary" onClick={handleNext}>
              Set Expiry Date{" "}
              <i className="bx bx-chevron-right align-middle"></i>
            </Button>
          </Modal.Footer>
        </div>
      )}

      {currentStep === 3 && (
        <div>
          <Modal.Header>
            <Modal.Title className="text-md">
              <div className="d-flex align-items-center column-gap-2">
                <button
                  className="border-0 bg-transparent flex-auto w-10 h-10 d-flex justify-content-center align-items-center bg-slate-100 rounded-circle"
                  onClick={handlePrev}
                >
                  <i className="bx bx-arrow-back"></i>
                </button>
                Set Expiry Date for the Offer
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12} sm={12} xs={12}>
                <label htmlFor="ExpiryDate" className="form-label">
                  Schedule Offer Expiry Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="ExpiryDate"
                  value={expiryDate}
                  onChange={handleChangeExpiryDate}
                />
                {expiryDateErr && <p className="error">{expiryDateErr}</p>}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <Button variant="primary" onClick={onSubmitExpiryDate}>
              Continue to Email Template
              <i className="bx bx-chevron-right align-middle"></i>
            </Button>
          </Modal.Footer>
        </div>
      )}

      {currentStep === 4 && (
        <div>
          <Modal.Header>
            <Modal.Title className="text-md">
              <div className="d-flex align-items-center column-gap-2">
                <button
                  className="border-0 bg-transparent flex-auto w-10 h-10 d-flex justify-content-center align-items-center bg-slate-100 rounded-circle"
                  onClick={handlePrev}
                >
                  <i className="bx bx-arrow-back"></i>
                </button>
                Choose Email Template
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="position-relative">
              <div className="search-div position-absolute top-0 right-0">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="pluto-search"></i>
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    name="emailTemplateSearchText"
                    value={emailTemplateSearchText}
                    onChange={handleChangeSearchText}
                  />
                </div>
              </div>
              <Tabs
                defaultActiveKey="tab1"
                id="template-tab-example"
                className="mb-3 nav-underline border-bottom tab-offer"
              >
                <Tab eventKey="tab1" title="All Templates">
                  <Row>
                    {allEmailTemplateList
                      .filter((emailTemplate) =>
                        emailTemplate.name
                          .toLowerCase()
                          .includes(emailTemplateSearchText.toLowerCase())
                      )
                      .map((emailTemplate) => (
                        <Col
                          lg={3}
                          md={4}
                          sm={6}
                          xs={6}
                          key={emailTemplate.gid}
                        >
                          <div className="selectRadio-box">
                            <input
                              type="radio"
                              id="a25"
                              name="check-substitution-2"
                            />
                            <label
                              className="p-4 rounded border border-2 border-slate-200 bg-slate-100 text-center"
                              htmlFor="a25"
                            >
                              <div className="offer-template rounded border border-slate-200 mb-2 h-150 bg-white overflow-hidden position-relative">
                                <button
                                  className="btn btn-primary position-absolute onSelect"
                                  onClick={() =>
                                    handleSelectEmailTemplate(emailTemplate)
                                  }
                                >
                                  Preview
                                </button>
                                <img
                                  src={
                                    emailTemplate.pdfimagesnippet ||
                                    "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg?20200913095930"
                                  }
                                  alt={emailTemplate.name}
                                  width={388}
                                  height={549}
                                  className="w-100 h-100 object-fit-contain"
                                />
                                <div className="radio-overlay position-absolute top-0 start-0 bottom-0 end-0 bg-white"></div>
                              </div>
                              <h4 className="mb-0 text-base font-semibold">
                                {emailTemplate.name}
                              </h4>
                            </label>
                          </div>
                        </Col>
                      ))}
                  </Row>
                </Tab>
                <Tab eventKey="tab2" title="Favorite">
                  <Row>
                    {allEmailTemplateList
                      .filter((emailTemplate1) => emailTemplate1.wishlist)
                      .filter((emailTemplate) =>
                        emailTemplate.name
                          .toLowerCase()
                          .includes(emailTemplateSearchText.toLowerCase())
                      )
                      .map((emailTemplate2) => (
                        <Col
                          lg={3}
                          md={4}
                          sm={6}
                          xs={6}
                          key={emailTemplate2.gid}
                        >
                          <div className="selectRadio-box">
                            <input
                              type="radio"
                              id="a29"
                              name="check-substitution-2"
                            />
                            <label
                              className="p-4 rounded border border-2 border-slate-200 bg-slate-100 text-center"
                              htmlFor="a29"
                            >
                              <div className="offer-template rounded border border-slate-200 mb-2 h-150 bg-white overflow-hidden position-relative">
                                <button
                                  className="btn btn-primary position-absolute onSelect"
                                  onClick={() =>
                                    handleSelectEmailTemplate(emailTemplate2)
                                  }
                                >
                                  Preview
                                </button>
                                <img
                                  src={
                                    emailTemplate2.pdfimagesnippet ||
                                    "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg?20200913095930"
                                  }
                                  alt={emailTemplate2.name}
                                  width={388}
                                  height={549}
                                  className="w-100 h-100 object-fit-contain"
                                />
                                <div className="radio-overlay position-absolute top-0 start-0 bottom-0 end-0 bg-white"></div>
                              </div>
                              <h4 className="mb-0 text-base font-semibold">
                                {emailTemplate2.name}
                              </h4>
                            </label>
                          </div>
                        </Col>
                      ))}
                  </Row>
                </Tab>
              </Tabs>
            </div>
          </Modal.Body>
        </div>
      )}

      {currentStep === 5 && (
        <div>
          <Modal.Header>
            <Modal.Title className="text-md">
              <div className="d-flex align-items-center column-gap-2">
                <button
                  className="border-0 bg-transparent flex-auto w-10 h-10 d-flex justify-content-center align-items-center bg-slate-100 rounded-circle"
                  onClick={handlePrev}
                >
                  <i className="bx bx-arrow-back"></i>
                </button>
                {selectedEmailTemplate?.name}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="p-4 d-flex flex-column row-gap-4">
              {selectedEmailTemplate.template && (
                <div
                  className="p-4"
                  dangerouslySetInnerHTML={{
                    __html: selectedEmailTemplate.template,
                  }}
                />
              )}

              <div className="d-flex flex-column row-gap-4">
                {/* <div className="d-flex flex-wrap gap-2">
                  <button className="px-2 py-2 text-sm rounded border border-slate-300 bg-transparent">
                    <span className="material-symbols-outlined align-middle">
                      attach_file
                    </span>{" "}
                    Attachment Files (3)
                  </button>
                  <button className="px-2 py-2 text-sm text-white rounded border border-blue-700 bg-blue-600">
                    <span className="material-symbols-outlined align-middle">
                      download
                    </span>{" "}
                    Download All
                  </button>
                </div> */}

                {selectedEmailTemplate.files &&
                  selectedEmailTemplate.files.length > 0 && (
                    <div className="d-flex flex-wrap gap-2">
                      {selectedEmailTemplate.files.map((file) => (
                        <div
                          className="px-4 py-2 text-sm rounded border border-slate-300 bg-slate-50 d-flex gap-2 align-items-center"
                          key={file.gid}
                        >
                          <span className="material-symbols-outlined">
                            description
                          </span>
                          <div className="d-flex flex-column">
                            <span className="text-sm font-semibold text-slate-800">
                              {file.name}
                            </span>
                            <span className="text-xs font-medium text-slate-500">
                              {file.size}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <Button
              variant="primary"
              onClick={isEmailTemplate ? onSubmitEmailTemplate : onSubmitOffer}
            >
              Send {isEmailTemplate ? "Email" : "Offer"}{" "}
              <i className="bx bx-chevron-right align-middle"></i>
            </Button>
          </Modal.Footer>
        </div>
      )}
    </Modal>
  );
};
